<template>
  <main-container>
    <a-card>
      <a-table :columns="columns" :data-source="tableData" :pagination="false">
        <template slot="order" slot-scope="roe, item, index">
          {{ tableData.length - index }}
        </template>
        <!-- <template slot="order_id" slot-scope="record">
                    <router-link :to="{ name: $routeName.orderDetail, query: { id: record.id } }">
                        <p :style="record.status == 8 ? 'background: red;color: #fff' : ''">{{ record.order_id }}</p>
                    </router-link>
                </template> -->
      </a-table>
    </a-card>
  </main-container>
</template>

<script>
import Order from '@/api/order';

const columns = [
  {
    key: 'order',
    title: '序号',
    scopedSlots: { customRender: 'order' },
  },
  {
    title: '时间',
    dataIndex: 'create_time',
  },
  {
    title: '订单号',
    dataIndex: 'order_id',
  },
  {
    title: '订单金额',
    dataIndex: 'amount',
  },
  {
    title: '收入',
    dataIndex: 'income',
  },
];

export default {
  name: 'dayOrder',
  data() {
    return {
      columns,
      tableData: [],
    };
  },
  created() {
    this.$route.meta.title = `${this.$route.query.date}订单`;
    this.getOrderLlist();
  },
  methods: {
    getOrderLlist() {
      Order.dayView({
        day: this.$route.query.date,
      }).then(res => {
        this.tableData = res.data;
      });
    },
  },
};
</script>
